import { useMemo } from 'react';
import { getAllColors, getColorByPath } from '../theme';

/**
 * Custom hook for accessing theme colors
 * @returns Object with color utilities and direct access to color values
 */
export const useThemeColors = () => {
  // Get all colors once and memoize them
  const colors = useMemo(() => getAllColors(), []);

  // Create a memoized function to get colors by path
  const getColor = useMemo(
    () =>
      (path: string): string | undefined => {
        return getColorByPath(path);
      },
    []
  );

  // Return an object with all the utilities and direct access to colors
  return {
    // Utility functions
    getColor,

    // Direct access to color categories
    primary: colors.primary,
    secondary: colors.secondary,
    text: colors.text,
    background: colors.background,
    border: colors.border,
    error: colors.error,
    success: colors.success,
    warning: colors.warning,
    info: colors.info,

    // All colors
    colors,
  };
};
